// PaymentScreen.jsx
import React from "react";
import { Row, Col, Input, message } from "antd";
import NumberFormat from "react-number-format";
import { StripeProvider } from "react-stripe-elements";
import PaymentCard from "../Questionary/PaymentCard";
import { priceForBudget } from "../../utils/pricing";
import AppConfig from "../config/AppConfig";
import { getQuestion } from "../../Api/Apis";

class PaymentScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fee: 0,
      firstCode: null,
      firstDiscount: 0,
      promoCode: "",
      promoCodeApplied: false,
      firstUsed: false,
      usedPromoCode: null,
      tierFirstDiscount: 0,
    };
  }

  componentDidMount() {
    const questionnaireId =
      JSON.parse(localStorage.getItem("BusinessQuestionnaireId")) || null;
    if (!questionnaireId) {
      message.warning("Questionnaire ID not found.");
      return;
    }

    this.fetchPromoUsage(questionnaireId).then(({ promoUsed, promoCode }) => {
      // your existing tier and rangeGoals logic
      const fromState = this.props.location?.state?.rangeGoals;
      let rangeGoals = fromState;
      if (!rangeGoals) {
        try {
          rangeGoals = JSON.parse(
            localStorage.getItem("lastBusinessRangeGoals")
          );
        } catch {
          rangeGoals = localStorage.getItem("lastBusinessRangeGoals");
        }
      }
      if (!rangeGoals) {
        message.warning("Could not determine budget range. Using default $0.");
        return;
      }
      const tier = priceForBudget(rangeGoals);
      if (!tier) {
        message.warning("Unknown budget range. Please contact support.");
        return;
      }

      this.setState({
        tierLabel: rangeGoals,
        ...tier,
        fee: tier.fee,
        firstCode: tier.code,
        firstDiscount: promoUsed ? 0 : tier.firstLeadDiscount,
        promoCode: promoUsed ? promoCode || tier.code : tier.code,
        promoCodeApplied: false,
        firstUsed: promoUsed,
        usedPromoCode: promoCode || null,
        tierFirstDiscount: tier.firstLeadDiscount,
      });
    });
  }

  async fetchPromoUsage(questionnaireId) {
    try {
      const response = await getQuestion(
        AppConfig["entityNames"]["questionnaires"],
        questionnaireId
      );
      const root = response?.data ?? {};
      const entity = root.entityData ?? root.data ?? root;
      const promoUsed = Boolean(entity?.promoUsed);
      const promoCode = entity?.promoCode ?? null;

      return { promoUsed, promoCode };
    } catch (error) {
      console.error("Failed to fetch promo usage:", error);
      return { promoUsed: false, promoCode: null };
    }
  }

  checkPromoCode = () => {
    const {
      firstCode,
      promoCode,
      promoCodeApplied,
      firstUsed,
      usedPromoCode,
      tierFirstDiscount,
    } = this.state;

    const input = (promoCode || "").trim().toUpperCase();
    const usedU = (usedPromoCode || "").toUpperCase();
    const firstU = (firstCode || "").toUpperCase();

    if (!input) {
      message.warning("Please enter a promo code.");
      return;
    }
    if (!firstCode) {
      message.warning("Pricing not ready yet. Please try again in a moment.");
      return;
    }
    if (promoCodeApplied) {
      message.info("Promo code already applied.");
      return;
    }
    // Block re-applying the SAME code (account-used or this session)
    if (input === usedU && usedU) {
      message.info(
        firstUsed
          ? "Promo code has already been used for this account."
          : "This promo code was already applied in this session."
      );
      return;
    }

    // Accept the tier code
    if (input === firstU) {
      const isFirstSignup = !firstUsed && !usedPromoCode;
      message.success(
        isFirstSignup
          ? "Promo code applied successfully."
          : `Code ${firstCode} applied.`
      );
      this.setState({
        promoCodeApplied: true,
        firstDiscount: tierFirstDiscount,
        usedPromoCode: input,
      });
    } else {
      message.error("Invalid code for this budget tier.");
    }
  };
  removePromoCode = () => {
    this.setState({
      promoCode: "",
      promoCodeApplied: false,
    });
  };

  render() {
    const subTotal = this.state.fee || 0;
    const discountAmount = this.state.promoCodeApplied
      ? this.state.firstDiscount || 0
      : 0;
    const total = Math.max(0, subTotal - discountAmount);

    const alreadyUsedSameCode =
      (this.state.usedPromoCode || "").toUpperCase() ===
      (this.state.promoCode || "").toUpperCase();

    return (
      <div className="business-signup-container">
        <Row>
          <Col span={24}>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <h1 style={{ fontWeight: "bold" }}>Payment Process</h1>
            </div>
          </Col>

          <Col
            xxl={{ span: 10, offset: 5 }}
            xl={{ span: 16, offset: 8 }}
            lg={{ span: 16, offset: 8 }}
            md={{ span: 16, offset: 8 }}
            sm={{ span: 16, offset: 3 }}
            xs={{ span: 11, offset: 3 }}
            style={{ zIndex: "1" }}
          >
            <div className="testSummary">
              <h3 className="summary">Summary</h3>

              <div className="TotalAmt">
                Sub Total{" "}
                <span className="testsCost">
                  <NumberFormat
                    value={subTotal}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </span>
              </div>

              <div className="TotalAmt">
                Discount{" "}
                <span className="testsCost">
                  <NumberFormat
                    value={discountAmount}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </span>
              </div>

              <div className="TotalAmt">
                Total{" "}
                <span className="testsCost">
                  <NumberFormat
                    value={total}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </span>
              </div>

              <div className="TotalAmt">
                <div>
                  <Row>
                    <Col lg={8} md={8} sm={8} xs={8}>
                      Promo Code
                    </Col>
                    <Col
                      lg={8}
                      md={8}
                      sm={8}
                      xs={8}
                      style={{ marginTop: "-8px" }}
                    >
                      <Input
                        name="promoCode"
                        onChange={(e) => {
                          const newCode = (e.target.value || "").toUpperCase();
                          let promoCodeApplied = this.state.promoCodeApplied;
                          if (
                            promoCodeApplied &&
                            newCode !== this.state.firstCode
                          ) {
                            promoCodeApplied = false;
                          }
                          this.setState({
                            promoCode: newCode,
                            promoCodeApplied,
                          });
                        }}
                        value={this.state.promoCode}
                      />
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={8}>
                      {!this.state.promoCodeApplied && this.state.promoCode ? (
                        <span
                          style={{
                            cursor: "pointer",
                            color: "#20a8d8",
                            float: "right",
                          }}
                          onClick={this.checkPromoCode}
                        >
                          Apply
                        </span>
                      ) : this.state.promoCodeApplied ? (
                        <span
                          style={{
                            cursor: "pointer",
                            color: "#20a8d8",
                            float: "right",
                          }}
                          onClick={() => {
                            this.setState({ promoCode: "" });
                            this.removePromoCode();
                          }}
                        >
                          Remove
                        </span>
                      ) : null}
                    </Col>
                  </Row>
                  {this.state.firstUsed && (
                    <div style={{ color: "orange", marginTop: "8px" }}>
                      Promo code has already been used for this account.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>

          <Col span={24} style={{ marginTop: "1vw" }}>
            <StripeProvider apiKey="pk_test_51LSfgsIlY9KGbjYfUeZ6tqu0otOOIuKEKPXa2uEc6YNOoXSBrc49KyLF0vzIL5Dolr7yr3YOARZDQlXOr8W2qrpF00txnvTR8Y">
              <PaymentCard
                amount={total}
                match={() => {
                  if (this.state.promoCodeApplied) {
                    localStorage.setItem("FIRST_LEAD_CODE_USED", "true");
                  }
                  // collect what you want to show in Companies2
                  const formData = this.props.formData || {};
                  const questionnaireId =
                    JSON.parse(
                      localStorage.getItem("BusinessQuestionnaireId") || "null"
                    ) || JSON.parse(localStorage.getItem("Step8") || "null");

                  this.props.history.push("/app/companies2", {
                    formData,
                    questionnaireId,
                  });
                }}
                formData={this.props.formData}
                promoCodeApplied={this.state.promoCodeApplied}
                firstCode={this.state.firstCode}
              />
            </StripeProvider>
          </Col>
        </Row>
      </div>
    );
  }
}

export default PaymentScreen;
